import api from "./axios";


export const loginApi = async(payload)=>{

    const response =
        await api.post(
            "/auth/login",
            {
                ...payload,
                platform:"web",
                deviceInfo:"Admin Web Portal"
            }
        );


    return response.data;

};

export const getLoggedInUserApi = async () => {
  const response = await api.get("/auth/me");

  return response.data;
};